import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { PwaUpdatePrompt } from "@/lib/pwa-register";
import { installChunkErrorRecovery } from "@/lib/force-refresh";
import { PushNotificationPrompt } from "@/components/push-prompt";
import "./index.css";

// If this tab was open across a release and a screen can no longer be loaded, refresh onto the new version once.
installChunkErrorRecovery();

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// Create the router
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  context: {
    queryClient,
  },
});

// Register the router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <PwaUpdatePrompt />
      <PushNotificationPrompt />
    </QueryClientProvider>
  </StrictMode>
);
